import React,{ useMemo } from "react";
import { useTranslation } from "react-i18next";
import func from "../../../services/functions";
import bigDecimal from "js-big-decimal";
const { round } = func;

const PaymentOrderTotals = ({ paymentOrder,setPaymentOrder }) => {
  const { t } = useTranslation("translations");
  const isAlbanian = paymentOrder.currency === "ALL";
  const currencyToDisplay = isAlbanian ? "Lek" : paymentOrder.currency;

  const totalInvoiceAmount = useMemo(()=>{
    return paymentOrder.paymentOrderRecords.reduce((acc,inv)=>bigDecimal.add(acc,inv.eInvoiceAmount),"0")
  },[paymentOrder.paymentOrderRecords])

  const paymentAmount = useMemo(()=>{
    return paymentOrder.paymentOrderRecords.reduce((acc,inv)=>bigDecimal.add(acc,inv.buyerPaidAmount),"0")
  },[paymentOrder.paymentOrderRecords])

  const openAmount = useMemo(()=>{
    return round(bigDecimal.subtract(totalInvoiceAmount, paymentAmount), 2)
  },[paymentAmount,totalInvoiceAmount])


  return (
    <div className="payment-totals-divider">
      <div className="d-flex flex-row align-items-start justify-content-between mt-1" style={{marginTop:30}}>
        <span className="fw-medium">
          <span>{t("paymentOrder.totalInvoiceAmount")}</span>
        </span>
        <span>
            {func.getFormattedMoneyValue(totalInvoiceAmount)}{" "}
          {currencyToDisplay}
        </span>
      </div>
      <div className="d-flex flex-row align-items-start justify-content-between" >
        <span className="fw-medium">
          <span>{t("paymentOrder.values")}</span>
        </span>
        <span>
          {func.getFormattedMoneyValue(paymentAmount)}{" "}
        </span>
      </div>
      <div className="d-flex flex-row align-items-start justify-content-between mt-1">
        <span>{t("paymentOrder.totalOpenAmount")}</span>
        <span>
            {func.getFormattedMoneyValue(openAmount)}{" "}
          {currencyToDisplay}
        </span>
      </div>
      <div className="d-flex flex-row align-items-start justify-content-between mt-1">
        <span>{t("paymentOrder.commissions")}</span>
        <span>
          {func.getFormattedMoneyValue("0")}{" "}
          {currencyToDisplay}
        </span>
      </div>
      <div className="d-flex flex-row align-items-start justify-content-between mt-1">
        <span className="fw-bold">
          <strong>{t("invoice.totalPay")}</strong>
        </span>
        <span>
            <strong>
            {func.getFormattedMoneyValue(paymentAmount)}{" "}
            {currencyToDisplay}
            </strong>
        </span>
      </div>
    </div>
  );
};

export default PaymentOrderTotals;
